export const CAMPAIGNS_START_DATE = 'CAMPAIGNS_START_DATE'
export const CAMPAIGNS_END_DATE = 'CAMPAIGNS_END_DATE'
export const SEARCH = 'CAMPAIGNS_SEARCH'
export const UPDATE_CAMPAIGNS = 'UPDATE_CAMPAIGNS'

export const setStartDate = payload => dispatch =>
  dispatch({
    type: CAMPAIGNS_START_DATE,
    payload: payload
  })
export const setEndDate = payload => dispatch =>
  dispatch({
    type: CAMPAIGNS_END_DATE,
    payload: payload
  })
export const searchQuery = payload => dispatch =>
  dispatch({
    type: SEARCH,
    payload: payload
  })
export const updateCampaigns = () => dispatch =>
  dispatch({
    type: UPDATE_CAMPAIGNS
  })
